import { Pipe, PipeTransform, inject } from '@angular/core';
import { TranslationService } from '../../core/i18n/translation.service';

@Pipe({
    name: 'translate',
    standalone: true,
    pure: false,
})
export class TranslatePipe implements PipeTransform {
    private readonly translationService = inject(TranslationService);

    transform(key: string, params?: Record<string, string>): string {
        return this.translationService.translate(key, params);
    }
}
